import React from "react";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faList, faCalendarAlt, faSliders, faTableList } from '@fortawesome/free-solid-svg-icons'
import MenuLayout from "./MenuLayout"
import { RouteInfoType } from "../../types/types";


import MenuListPage from "./pages/menusList/MenusList";
import BookingMenusList from "./pages/bookingMenusList/BookingMenusList";
import MenuEditorPage from "./pages/menuEditor/MenuEditor";
import BookingEditorPage from "./pages/bookingEditor/BookingEditorPage";
import ModifiersSetPage from "./pages/modifiersSet/ModifiersSetList";
import EditModifiersSetPage from "./pages/modifiersSet/components/EditModifiersSetPage";
import EditMenuItemPage from "./pages/menuEditor/EditMenuItemPage";
import EditBookingItemPage from "./pages/bookingEditor/EditBookingItemPage";
import TablesManagementPage from "./pages/tables/index";
import OrdersSettingsPage from "./pages/orderSettingsPage/OrdersSettingsPage";
import { IconProp } from "@fortawesome/fontawesome-svg-core";


const menuRoutes = [
    {
        id: "menus",
        name: "menu",
        header: "menu",
        path: "/menus",
        component: MenuLayout,
        nonCollapsable: true,
        icon: <FontAwesomeIcon icon={faList as IconProp} size={"lg"}/>,
        routes: [
            {
                path: "/menus/regular/list",
                name: "menuList",
                component: MenuListPage,
                icon: <FontAwesomeIcon icon={faList as IconProp} size={"lg"}/>,
            },
            // {
            //     path: "/menus/bookings/list",
            //     name: "bookingList",
            //     component: BookingMenusList,
            //     icon: <FontAwesomeIcon icon={faCalendarAlt as IconProp} size={"lg"}/>,
            // },
            {
                path: "/menus/modifiers/list",
                name: "modifiers",
                component: ModifiersSetPage,
                icon: <FontAwesomeIcon icon={faSliders as IconProp} size={"lg"}/>,

            },
            {
                path: "/menus/tables/list",
                name: "tables",
                component: TablesManagementPage,
                icon: <FontAwesomeIcon icon={faTableList as IconProp} size={"lg"}/>,
            },
            {
                hide: true,
                path: "/menus/modifiers/:modifierId/view",
                name: "",
                component: EditModifiersSetPage,

            },

            {
                hide: true,
                path: "/menus/:menuType/settings/:menuId",
                name: "ordersSettings",
                component: OrdersSettingsPage
            },
            {
                hide: true,
                path: "/menus/regular/:menuId/view",
                name: "menuEditor",
                component: MenuEditorPage
            },
            {
                hide: true,
                path: "/menus/booking/:menuId/view",
                name: "menuEditor",
                component: BookingEditorPage
            },
            {
                hide: true,
                path: "/menus/regular/:menuId/:categoryId/:menuItemId",
                name: "editMenuItem",
                component: EditMenuItemPage
            },
            {
                hide: true,
                path: "/menus/booking/:menuId/:categoryId/:menuItemId",
                name: "editMenuItem",
                component: EditBookingItemPage
            },
        ]
    }
]

export default menuRoutes as RouteInfoType[];
